import { Box } from '@radix-ui/themes';
import { CommonConfirmationDialog } from 'components/common/dialogs/confirmation';
import { MachineModelsContext } from 'contexts/admin/machine-models.context';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IMachineModel } from 'lib_ts/interfaces/modelling/i-machine-model';
import { FC, useContext } from 'react';

interface IProps {
  models: IMachineModel[];
  onClose: () => void;
}

export const ArchiveModelsDialog: FC<IProps> = (props) => {
  const { archiveModels } = useContext(MachineModelsContext);
  const isSingle = props.models.length === 1;

  return (
    <CommonConfirmationDialog
      identifier="ArchiveModelsDialog"
      maxWidth={RADIX.DIALOG.WIDTH.MD}
      title={isSingle ? 'Archive Model' : 'Archive Models'}
      content={
        <Box>
          <p>
            Are you sure you want to archive the following{' '}
            {isSingle ? 'model' : 'models'}?
          </p>
          <ul>
            {props.models.map((m, i) => (
              <li key={`model-${i}`}>{m.name}</li>
            ))}
          </ul>
        </Box>
      }
      action={{
        label: 'common.archive',
        color: RADIX.COLOR.DANGER,
        invisible: props.models.length === 0,
        onClick: () => archiveModels(props.models.map((u) => u._id)),
      }}
      cancel={{
        onClick: props.onClose,
      }}
    />
  );
};
